import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { updatePersonalSettings } from '@ebalance/proto/bffuser/v1/setting_service-SettingService_connectquery'
import {
  UpdatePersonalSettingsRequestSchema,
  UpdatePersonalSettingsResponseSchema,
} from '@ebalance/proto/bffuser/v1/setting_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * UpdatePersonalSettings ミューテーションフック。
 * FieldMask (update_mask) を含むリクエストを BFF に送る。
 * onSuccess / onError の callbacks は呼び出し側 (usePersonalSettings) で注入する。
 */
export function useUpdatePersonalSettingsMutation(): UseMutationResult<
  MessageShape<typeof UpdatePersonalSettingsResponseSchema>,
  ConnectError,
  MessageInitShape<typeof UpdatePersonalSettingsRequestSchema>
> {
  return useMutation(updatePersonalSettings)
}
